"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncReduce = asyncReduce;
exports.default = void 0;

var _asyncIterable = require("../../internal/async-iterable");

async function asyncReduce(iterable, initial, reducer) {
  let c = 0;
  let result = initial;
  const iterator = iterable[Symbol.asyncIterator]();

  try {
    if (initial === undefined) {
      const firstResult = await iterator.next();

      if (firstResult.done) {
        throw new Error('Cannot reduce: no initial value specified and iterable was empty');
      }

      result = firstResult.value;
      c = 1;
    }

    let nextItem;

    while (!(nextItem = await iterator.next()).done) {
      result = await reducer(result, nextItem.value, c++);
    }

    return result;
  } finally {
    if (typeof iterator.return === 'function') await iterator.return();
  }
}

var _default = (0, _asyncIterable.asyncIterableCurry)(asyncReduce, {
  reduces: true,
  minArgs: 1,
  maxArgs: 2
});

exports.default = _default;